/**
 * Created by Vladislav on 19.02.2026.
 */

const LevelDialogueAction = function (f) {
    if (this.level.isRegular() && this.game.outcome === GameBase.OUTCOME_VICTORY) {
        if (cleverapps.Plot.getDialogueAfterLevel(this.level)) {
            cleverapps.Plot.finishLevelDialogue(f, this.level);
            return;
        }
    }

    f();
};